import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useLayoutEffect } from 'react';
import './Popup.scss';
import { isElementInViewport } from '../../utils';
import { Modal } from '../modal/Modal';
export function Popup(props) {
    const thisRef = useRef(null);
    const [top, setTop] = useState(0);
    const [left, setLeft] = useState(0);
    const [show, setShow] = useState(false);
    const thisRect = useRef({ width: 0, height: 0 }); // TODO // new DOMRect(0, 0, 0, 0) // DOMRect is not supported in IE11
    const triggerRect = props.triggerRef.current?.getBoundingClientRect() ?? {
        top: 0,
        left: 0,
        width: 0,
        height: 0,
    };
    useLayoutEffect(() => {
        if (thisRef.current) {
            const getPosition = () => {
                // Po zobrazeni se zjistuje jestli se menu veslo do viewportu,
                // pokud ano tak ok, pokud ne tak se vyzkousi dalsi mozna pozice
                const yTop = window.pageYOffset + triggerRect.top, xLeft = window.pageXOffset + triggerRect.left;
                let top = 0, left = 0;
                props.position.some((testPosition) => {
                    switch (testPosition) {
                        case 'top-left':
                        case 'top-center':
                        case 'top-right':
                            top = yTop - thisRect.current.height;
                            break;
                        case 'bottom-left':
                        case 'bottom-center':
                        case 'bottom-right':
                            top = yTop + triggerRect.height;
                            break;
                        case 'left-center':
                        case 'right-center':
                            top = yTop + triggerRect.height / 2 - thisRect.current.height / 2;
                            break;
                        case 'left-top':
                        case 'right-top':
                            top = yTop;
                            top = yTop + triggerRect.height - thisRect.current.height;
                            break;
                        case 'left-bottom':
                        case 'right-bottom':
                            top = yTop;
                            break;
                    }
                    switch (testPosition) {
                        case 'top-left':
                        case 'bottom-left':
                            left = xLeft + triggerRect.width - thisRect.current.width;
                            break;
                        case 'top-center':
                        case 'bottom-center':
                            left = xLeft + triggerRect.width / 2 - thisRect.current.width / 2;
                            break;
                        case 'top-right':
                        case 'bottom-right':
                            left = xLeft;
                            break;
                        case 'left-top':
                        case 'left-center':
                        case 'left-bottom':
                            left = xLeft - thisRect.current.width;
                            break;
                        case 'right-top':
                        case 'right-center':
                        case 'right-bottom':
                            left = xLeft + triggerRect.width;
                            break;
                    }
                    top = Math.floor(top);
                    left = Math.floor(left);
                    if (thisRef.current) {
                        thisRef.current.style.top = `${top}px`;
                        thisRef.current.style.left = `${left}px`;
                    }
                    return thisRef.current ? isElementInViewport(thisRef.current) : false;
                });
                return { top, left };
            };
            thisRect.current = thisRef.current.getBoundingClientRect();
            const { top, left } = getPosition();
            setTop(top);
            setLeft(left);
            setShow(true);
        }
    }, [triggerRect.height, triggerRect.left, triggerRect.top, triggerRect.width, props.position]);
    const className = show ? ' sg-popup-isShown' : '';
    return (_jsx(Modal, { children: _jsx("div", { className: 'sg-popup' + className, ref: thisRef, style: {
                top: top,
                left: left,
                width: props.sameWidthAsTrigger ? triggerRect.width : undefined,
            }, children: props.children }) }));
}
//# sourceMappingURL=Popup.js.map